import React from 'react'
import { FormattedMessage } from 'react-intl'

import { getScoreRange } from './utils'
import {
  MAX_SCORE,
  MIN_SCORE,
  VARIANT_NUMBER,
  VARIANT_SQUARE,
  SIZE_BIG,
  SIZE_MEDIUM,
  SIZE_SMALL,
} from './constants'
import { ScoreRating, ScoreBase, Category } from './styles'
import messages from './messages'

export type variantsType = typeof VARIANT_NUMBER | typeof VARIANT_SQUARE
export type sizesType = typeof SIZE_BIG | typeof SIZE_MEDIUM | typeof SIZE_SMALL

interface IScoreProps {
  value?: number
  variant?: variantsType
  size?: sizesType
  withCategory?: boolean
  asymetricRoundedShape?: boolean
  toFixed?: number
  neutral?: boolean
}

const Score = ({
  value = 0,
  variant = VARIANT_SQUARE,
  withCategory = false,
  size = SIZE_MEDIUM,
  asymetricRoundedShape = false,
  toFixed = 1,
  neutral = false,
}: IScoreProps) => {
  if (!value || value < MIN_SCORE || value > MAX_SCORE) {
    return null
  }

  const category = getScoreRange(value, neutral)
  const messageKey = `score${category.level}`
  const message = messages[messageKey as keyof typeof messages]

  return (
    <ScoreBase>
      <ScoreRating
        data-testid="score"
        color={category.color}
        variant={variant}
        size={size}
        asymetricRoundedShape={asymetricRoundedShape}
      >
        {value.toFixed(toFixed)}
      </ScoreRating>
      {withCategory && (
        <Category color={category.color} size={size} data-testid="category">
          <FormattedMessage {...message} />
        </Category>
      )}
    </ScoreBase>
  )
}

export default Score
